import { DefaultState } from 'store/types';
import { LocationRoomsData } from "store/reducers/room/locationRooms/types";

export const GET_LOCATION_MATCHES_BY_REQUEST_DATA_REQUEST = 'GET_LOCATION_MATCHES_BY_REQUEST_DATA_REQUEST';
export const GET_LOCATION_MATCHES_BY_REQUEST_DATA_SUCCESS = 'GET_LOCATION_MATCHES_BY_REQUEST_DATA_SUCCESS';
export const GET_LOCATION_MATCHES_BY_REQUEST_DATA_FAILURE = 'GET_LOCATION_MATCHES_BY_REQUEST_DATA_FAILURE';
export const GET_LOCATION_MATCHES_BY_REQUEST_DATA_CLEAR = 'GET_LOCATION_MATCHES_BY_REQUEST_DATA_CLEAR';

interface LocationCoords {
  longitude: number;
  latitude: number;
}

export interface GetLocationMatchesByRequestParams {
  address?: string;
  location: LocationCoords;
  miles: number;
  fromDate: Date;
  toDate?: Date;
  lodgingsWithRoomsOnly?: boolean;
  paging?: {
    page: number;
    pageSize: number;
  }
}

export interface GetLocationMatchesByRequestRowResponse {
  rows: GetLocationMatchesByRequestRow[];
  rowsCount: number;
  hasMore: boolean;
}

export interface GetLocationMatchesByRequestRow {
  address: string;
  compatibileGuestsCount: number;
  compatibility: number;
  distance: number;
  id: string;
  isAnyReservations: boolean;
  lodgingType: string;
  maxRate: number;
  minRate: number;
  name: string;
  likesCount: number;
  notesCount: number;
  totalBookedCount: number;
  totalOccupancy: number;
  bookingStatus?: string;
  data?: LocationRoomsData;
}

export type GetLocationMatchesByRequestData = GetLocationMatchesByRequestRowResponse;

export type GetLocationMatchesByRequestState = DefaultState & {
  contents?: GetLocationMatchesByRequestData;
};

interface GetLocationMatchesByRequestDataRequest {
  type: typeof GET_LOCATION_MATCHES_BY_REQUEST_DATA_REQUEST;
}

interface GetLocationMatchesByRequestDataSuccess {
  type: typeof GET_LOCATION_MATCHES_BY_REQUEST_DATA_SUCCESS,
  contents: GetLocationMatchesByRequestData;
}

interface GetLocationMatchesByRequestDataFailure {
  type: typeof GET_LOCATION_MATCHES_BY_REQUEST_DATA_FAILURE;
}

interface GetLocationMatchesByRequestDataClear {
  type: typeof GET_LOCATION_MATCHES_BY_REQUEST_DATA_CLEAR,
  contents: [];
}

export type GetLocationMatchesByRequestActionTypes = GetLocationMatchesByRequestDataRequest | GetLocationMatchesByRequestDataSuccess | GetLocationMatchesByRequestDataFailure | GetLocationMatchesByRequestDataClear;